import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/ui/layout.js";
import { Link } from 'gatsby';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Recipes for learning how to use and apply `}<inlineCode parentName="p">{`unified-doc`}</inlineCode>{` to build interactive document applications.`}</p>
    <ul>
      <li parentName="ul"><Link to="./doc" mdxType="Link">Doc</Link></li>
      <li parentName="ul"><Link to="./compiler" mdxType="Link">Compiler</Link></li>
      <li parentName="ul"><Link to="./parsers" mdxType="Link">Parsers</Link></li>
      <li parentName="ul"><Link to="./sanitization" mdxType="Link">Sanitization</Link></li>
      <li parentName="ul"><Link to="./text-content" mdxType="Link">Text content</Link></li>
      <li parentName="ul"><Link to="./file" mdxType="Link">File</Link></li>
      <li parentName="ul"><Link to="./marks" mdxType="Link">Marks</Link></li>
      <li parentName="ul"><Link to="./search" mdxType="Link">Search</Link></li>
      <li parentName="ul"><Link to="./styling" mdxType="Link">Styling</Link></li>
      <li parentName="ul"><Link to="./plugins" mdxType="Link">Plugins</Link></li>
      <li parentName="ul"><Link to="./syntax-highlighting" mdxType="Link">Syntax highlighting</Link></li>
      <li parentName="ul"><Link to="./react" mdxType="Link">React</Link></li>
      <li parentName="ul"><Link to="./doc-api" mdxType="Link">Doc API</Link></li>
      <li parentName="ul"><Link to="./dom-api" mdxType="Link">DOM API</Link></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      